
import { Home, Briefcase, Users } from "lucide-react";
import { useLocation, Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function TabBar() {
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    {
      name: "Home",
      href: "/",
      icon: Home,
      exact: true
    },
    {
      name: "Jobs",
      href: "/jobs",
      icon: Briefcase,
      exact: false
    },
    {
      name: "Trades",
      href: "/trades",
      icon: Users,
      exact: false
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 tab-bar pb-safe">
      <div className="grid grid-cols-3 h-16">
        {tabs.map((tab) => {
          const isActive = tab.exact 
            ? currentPath === tab.href
            : currentPath.startsWith(tab.href) && tab.href !== '/' || currentPath === tab.href;

          return (
            <Link
              key={tab.name}
              to={tab.href}
              className={cn(
                "flex flex-col items-center justify-center h-full",
                "transition-colors duration-200",
                isActive 
                  ? "text-black" 
                  : "text-gray-400 hover:text-gray-500"
              )}
              aria-label={tab.name}
            >
              {tab.name === "Home" ? (
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className={cn(
                    "mb-1",
                    isActive ? "text-black" : "text-gray-400"
                  )}
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              ) : (
                <tab.icon className={cn(
                  "h-6 w-6 mb-1",
                  isActive ? "text-black" : "text-gray-400"
                )} />
              )}
              <span className="text-xs font-medium">{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
